import React, { useContext, useEffect } from 'react';
import { Watermark } from '@mummssoftware/common-ui';
import { Snackbar } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { docErrorCodes } from '@mummssoftware/utils/hope';
import { HopeContext } from '../Context/HopeWidgetContext';
import { Context } from '../../context';
import { HopeItemExpandedTable } from './HopeItemExpandedTable';
import { Container } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string;
}>;

type HopeItemSetProps = {
  smallWidget?: boolean;
  hopeDTOProp: string;
};
const getErrorColor = (palette: any, patientHopeDocData: any[]) => {
  if (patientHopeDocData.every((row: any) => row.errorlevel <= 1)) {
    return palette?.success?.main;
  }
  return palette?.error?.main;
};

export const HopeReviewDocument = ({
  smallWidget,
  hopeDTOProp,
}: HopeItemSetProps) => {
  const { watermark, errorInfo, clearError } = useContext(Context);
  const { patientHopeDocData } = useContext(HopeContext);
  const { palette } = useTheme();

  const Alert = (props: AlertProps) => (
    <MuiAlert elevation={6} variant="filled" {...props} />
  );
  return (
    <>
      <Container
        id="hope-item-set-container"
        style={{
          border: `solid ${getErrorColor(palette, patientHopeDocData)} 3px`,
          padding: '5px',
          borderRadius: '5px',
        }}
      >
        {watermark && watermark.show ? (
          <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
        ) : null}
        <Snackbar
          open={!!errorInfo}
          autoHideDuration={3000}
          onClose={() => clearError()}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert onClose={() => clearError()} severity="error">
            {errorInfo}
          </Alert>
        </Snackbar>
        <HopeItemExpandedTable hopeDTOProp={hopeDTOProp} />
      </Container>
    </>
  );
};

export default HopeReviewDocument;
